# Naive check to see if it looks like the text contains a URL
module.exports = (text) ->
  /// \b https?:// ///.test(text)
